
export default {
  name: "Cal-Center-Heading",
  props: {
    headingContent: {
      type: String,
      default: "",
    },
    alignment: {
      type: String,
      default: "",
    },
    padding: {
      type: String,
      default: "py-5",
    },
  },
};
